import React from 'react';
import Isvg from 'react-inlinesvg';
import PropTypes from 'prop-types';
import { uniqueId } from 'lodash';

import bronze0 from '../../assets/badges/Bronze/Bronze0.svg';
import bronze1 from '../../assets/badges/Bronze/Bronze1.svg';
import bronze2 from '../../assets/badges/Bronze/Bronze2.svg';
import bronze3 from '../../assets/badges/Bronze/Bronze3.svg';
import bronze4 from '../../assets/badges/Bronze/Bronze4.svg';
import bronze5 from '../../assets/badges/Bronze/Bronze5.svg';
import silver0 from '../../assets/badges/Silver/Silver0.svg';
import silver1 from '../../assets/badges/Silver/Silver1.svg';
import silver2 from '../../assets/badges/Silver/Silver2.svg';
import silver3 from '../../assets/badges/Silver/Silver3.svg';
import silver4 from '../../assets/badges/Silver/Silver4.svg';
import silver5 from '../../assets/badges/Silver/Silver5.svg';
import gold0 from '../../assets/badges/Gold/Gold0.svg';
import gold1 from '../../assets/badges/Gold/Gold1.svg';
import gold2 from '../../assets/badges/Gold/Gold2.svg';
import gold3 from '../../assets/badges/Gold/Gold3.svg';
import gold4 from '../../assets/badges/Gold/Gold4.svg';
import gold5 from '../../assets/badges/Gold/Gold5.svg';
import platinum0 from '../../assets/badges/Platinum/Platinum0.svg';
import platinum1 from '../../assets/badges/Platinum/Platinum1.svg';
import platinum2 from '../../assets/badges/Platinum/Platinum2.svg';
import platinum3 from '../../assets/badges/Platinum/Platinum3.svg';
import platinum4 from '../../assets/badges/Platinum/Platinum4.svg';
import platinum5 from '../../assets/badges/Platinum/Platinum5.svg';
import emerald0 from '../../assets/badges/Emerald/Emerald0.svg';
import emerald1 from '../../assets/badges/Emerald/Emerald1.svg';
import emerald2 from '../../assets/badges/Emerald/Emerald2.svg';
import emerald3 from '../../assets/badges/Emerald/Emerald3.svg';
import emerald4 from '../../assets/badges/Emerald/Emerald4.svg';
import emerald5 from '../../assets/badges/Emerald/Emerald5.svg';
import diamond0 from '../../assets/badges/Diamond/Diamond0.svg';
import diamond1 from '../../assets/badges/Diamond/Diamond1.svg';
import diamond2 from '../../assets/badges/Diamond/Diamond2.svg';
import diamond3 from '../../assets/badges/Diamond/Diamond3.svg';
import diamond4 from '../../assets/badges/Diamond/Diamond4.svg';
import diamond5 from '../../assets/badges/Diamond/Diamond5.svg';
import epic0 from '../../assets/badges/Epic/Epic0.svg';
import epic1 from '../../assets/badges/Epic/Epic1.svg';
import epic2 from '../../assets/badges/Epic/Epic2.svg';
import epic3 from '../../assets/badges/Epic/Epic3.svg';
import epic4 from '../../assets/badges/Epic/Epic4.svg';
import epic5 from '../../assets/badges/Epic/Epic5.svg';
import legend0 from '../../assets/badges/Legend/Legend0.svg';
import legend1 from '../../assets/badges/Legend/Legend1.svg';
import legend2 from '../../assets/badges/Legend/Legend2.svg';
import legend3 from '../../assets/badges/Legend/Legend3.svg';
import legend4 from '../../assets/badges/Legend/Legend4.svg';
import legend5 from '../../assets/badges/Legend/Legend5.svg';
import bronzePast from '../../assets/past-ribbons/ribbon-bronze.svg';
import silverPast from '../../assets/past-ribbons/ribbon-silver.svg';
import goldPast from '../../assets/past-ribbons/ribbon-gold.svg';

const CertificateIcon = ({ rank, className, total }) => {
    const numGems = total > 5 ? 5 : total;
    const iconDictionary = {
        bronze0,
        bronze1,
        bronze2,
        bronze3,
        bronze4,
        bronze5,
        silver0,
        silver1,
        silver2,
        silver3,
        silver4,
        silver5,
        gold0,
        gold1,
        gold2,
        gold3,
        gold4,
        gold5,
        platinum0,
        platinum1,
        platinum2,
        platinum3,
        platinum4,
        platinum5,
        emerald0,
        emerald1,
        emerald2,
        emerald3,
        emerald4,
        emerald5,
        diamond0,
        diamond1,
        diamond2,
        diamond3,
        diamond4,
        diamond5,
        epic0,
        epic1,
        epic2,
        epic3,
        epic4,
        epic5,
        legend0,
        legend1,
        legend2,
        legend3,
        legend4,
        legend5,
        bronzePast,
        silverPast,
        goldPast
    };

    const src = rank.includes('Past') ? rank : `${rank}${numGems || 0}`;
    const imgSrc = iconDictionary[src] || '';
    return <Isvg src={imgSrc} className={className} key={uniqueId()} />;
};

CertificateIcon.propTypes = {
    className: PropTypes.string,
    rank: PropTypes.string,
    total: PropTypes.number
};

export default CertificateIcon;



// WEBPACK FOOTER //
// ./components/certificate-icon/certificate-icon.js